import { Mark, Node } from "tiptap";
import { toggleMark } from "tiptap-commands";

export default class HLight extends Mark {

    get name() {
        return "hlight";
    }

    get defaultOptions() {
        return {
            flag: [1, 2, 3]
        };
    }

    get schema() {
        return {
            attrs: {
                flag: {
                    default: 1
                }
            },
            defining: true,

            parseDOM: [
                {
                    tag: "span.hlight",
                    getAttrs(dom) {
                        return { flag: 1 };
                    }
                },


            ],
            toDOM: mark => {
                return ["span", { class: `hlight flag${mark.attrs.flag}` }, 0]
            }
        }
    }

    commands({ type }) {
        return attrs => {
            return toggleMark(type, attrs);
        }
    }
}